import React, { Component } from 'react'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import './App.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faUserClock,
    faEdit,
    faPlus,
    faSort,
    faEye,
    faSlidersH,
    faSearch,
    faTimes,
    faExclamationTriangle,
    faBars,
} from '@fortawesome/free-solid-svg-icons'
import _ from 'lodash'
import Login from './components/user/Login'
import NoMatch from './components/NoMatch'
import Layout from './components/Layout'
import PublicLayout from './components/PublicLayout'
import { checkAuthentication, getSettings } from './api/userapi'
import privateRoutes from './components/routes/privateRoutes'
import publicRoutes from './components/routes/publicRoutes'
import sessionRoutes from './components/routes/sessionRoutes'
import CacheBuster from './cacheBuster'
import { initGTM, PageView } from './components/tracking/tracking'

library.add(
    faUserClock,
    faEdit,
    faPlus,
    faSort,
    faEye,
    faSlidersH,
    faSearch,
    faTimes,
    faExclamationTriangle,
    faBars
)

class App extends Component {
    constructor(props) {
        super(props)
        this.state = { settings: {} }
    }

    componentDidMount() {
        this.props.checkAuthenticationConnect()
        this.props.getSettings(function (result, _this) {
            _this.getData(result, _this)
        }, this)
    }

    getData(value, _this) {
        _this.setState({
            settings: value.data.value.environment,
        })
        switch (this.state.settings) {
            case 'dev':
                initGTM('GTM-TSSK8LL')
                break
            case 'qa':
                initGTM('GTM-PSLZSTK')
                break
            case 'staging':
                initGTM('GTM-PSLZSTK')
                break
            case 'prod':
                initGTM('GTM-5LQP62R')
                break
            default:
                initGTM('GTM-TSSK8LL')
        }

        PageView();
    }

    render() {
        const { isAuthenticated } = this.props
        return (
            <CacheBuster>
                {({ loading, isLatestVersion, refreshCacheAndReload }) => {
                    if (loading) {
                        return null
                    }
                    if (!loading && !isLatestVersion) {
                        refreshCacheAndReload()
                    }
                    return (
                        <BrowserRouter>
                            <Switch>
                                {_.map(publicRoutes, (route, key) => {
                                    const { component, path } = route
                                    return (
                                        <Route
                                            exact
                                            path={path}
                                            key={key}
                                            render={route => <PublicLayout component={component} route={route} />}
                                        />
                                    )
                                })}

                                {_.map(privateRoutes, (route, key) => {
                                    const { component, path } = route
                                    return (
                                        <Route
                                            exact
                                            path={path}
                                            key={key}
                                            render={route =>
                                                isAuthenticated ? (
                                                    <Layout component={component} route={route} />
                                                ) : (
                                                    <PublicLayout component={Login} route={route} />
                                                )
                                            }
                                        />
                                    )
                                })}

                                {_.map(sessionRoutes, (route, key) => {
                                    const { component, path } = route
                                    return (
                                        <Route
                                            exact
                                            path={path}
                                            key={key}
                                            render={route =>
                                                isAuthenticated ? (
                                                    <Redirect to="/secure/gifts" />
                                                ) : (
                                                    <PublicLayout component={component} route={route} />
                                                )
                                            }
                                        />
                                    )
                                })}

                                <Route component={NoMatch} />
                            </Switch>
                        </BrowserRouter>
                    )
                }}
            </CacheBuster>
        )
    }
}

export default connect(
    state => {
        return {
            isAuthenticated: state.data.isAuthenticated,
        }
    },
    dispatch => ({
        checkAuthenticationConnect: () => {
            dispatch(checkAuthentication())
        },
        getSettings: (callback, context) => {
            dispatch(getSettings(callback, context))
        },
    })
)(App)
